<div class="imp-coming-soon">
    <div class="ipm-coming-soon-section">
        <img priority src="./assets/imgs/beat22-logo/main-logo-beat22.svg" alt="beat22-logo">
        <h1>Exciting News!</h1>
        <p>illpeoplemusic is now <b>Beat22.com!</b> While we transition, you can continue accessing us at <b>illpeoplemusic.com</b> for now. We’ll be live on <b>Beat22.com</b> very soon—stay tuned!</p>
        <button class="ipm-button" (click)="goToIllpeopleMusic()">Visit Now</button>
    </div>
</div>
